import { CommonApiResponseType } from 'src/models/BaseApi';
import { CauseItemResponseType, CauseSaveRequestType, CauseSaveResponseType } from 'src/models/Causes';
import {
  CommonListCopyItemRequestType,
  CommonDeleteItemRequestType,
  CommonDeleteItemResponseType,
  CommonGetItemRequestType,
  CommonListCopyItemResponseType,
  CommonListReorderType,
  CommonListRequestType,
  CommonListResponseType,
  CommonListReorderResponseType,
} from 'src/models/listTypes';
import { httpPost } from 'src/utils/http';

const getPath = (str: string) => `/setupcauses/${str}`;

/** get causes list */
export const apiGetCausesList = ({
  limit,
  campaignID,
  offset,
}: CommonListRequestType): Promise<CommonListResponseType> =>
  httpPost(getPath('LoadItems'), {
    BatchSize: limit,
    CampaignID: campaignID,
    LoadFromIndex: offset,
  });

/** delete a cause */
export const apiDeleteCause = (id: CommonDeleteItemRequestType): Promise<CommonDeleteItemResponseType> =>
  httpPost(getPath('DeleteItem'), {
    ItemID: id,
  });

/** get cause details */
export const apiGetCauseItem = (id: CommonGetItemRequestType): Promise<CauseItemResponseType> =>
  httpPost(getPath('LoadItemDetails'), {
    ItemID: id,
  });

/** copy a cause item */
export const apiCopyCauseItem = (id: CommonListCopyItemRequestType): Promise<CommonListCopyItemResponseType> =>
  httpPost(getPath('CopyItem'), {
    ItemID: id,
  });

/** save a cause item */
export const apiSaveCauseItem = (data: CauseSaveRequestType): Promise<CauseSaveResponseType> =>
  httpPost(getPath('SaveItem'), data);

/** reorder cause items */
export const apiReorderCauseList = (data: CommonListReorderType): Promise<CommonListReorderResponseType> =>
  httpPost(getPath('ReorderItem'), {
    ItemId: data[0],
    NewSequence: data[2] + 1,
  });

/** save info */
export const apiSaveCauseInfo = (data: {
  IsImagesEnabled: boolean;
  CampaignID: number;
}): Promise<CommonApiResponseType> => httpPost(getPath('saveitemsglobal'), data);
